/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_massmol_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A dilution calculator (C1V1 = C2V2) works out how to dilute an existing stock solution. This calculator works out how much solid compound to weigh out to make a solution from scratch.`)
};

const es_massmol_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una calculadora de dilución (C1V1 = C2V2) calcula cómo diluir una solución madre existente. Esta calculadora calcula cuánto compuesto sólido pesar para preparar una solución desde cero.`)
};

const de_massmol_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Verdünnungsrechner (C1V1 = C2V2) berechnet, wie eine vorhandene Stammlösung verdünnt wird. Dieser Rechner berechnet, wie viel festen Stoff Sie einwiegen müssen, um eine Lösung von Grund auf herzustellen.`)
};

const nl_massmol_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een verdunningscalculator (C1V1 = C2V2) berekent hoe je een bestaande stockoplossing verdunt. Deze calculator berekent hoeveel vaste stof je moet afwegen om een oplossing helemaal opnieuw te maken.`)
};

const fr_massmol_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un calculateur de dilution (C1V1 = C2V2) détermine comment diluer une solution mère existante. Ce calculateur détermine la quantité de composé solide à peser pour préparer une solution à partir de zéro.`)
};

const it_massmol_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un calcolatore di diluizione (C1V1 = C2V2) calcola come diluire una soluzione madre esistente. Questo calcolatore calcola quanto composto solido pesare per preparare una soluzione da zero.`)
};

const pt_br2_massmol_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma calculadora de diluição (C1V1 = C2V2) calcula como diluir uma solução estoque já existente. Esta calculadora determina quanto composto sólido pesar para preparar uma solução do zero.`)
};

const pt_massmol_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma calculadora de diluição (C1V1 = C2V2) determina como diluir uma solução-mãe já existente. Esta calculadora determina quanto composto sólido pesar para preparar uma solução de raiz.`)
};

const ja_massmol_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`希釈計算ツール (C1V1 = C2V2) は既存のストック溶液をどう希釈するかを計算します。このツールは、溶液をゼロから作るためにどれだけの固体化合物を秤量すればよいかを計算します。`)
};

const zh_massmol_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`稀释计算器（C1V1 = C2V2）用于计算如何稀释现有的母液。而本计算器用于计算从零开始配制溶液时需要称量多少固体化合物。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const massmol_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.massmol_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("massmol_faq_a4", locale)
	if (locale === "en") return en_massmol_faq_a4(inputs)
	if (locale === "es") return es_massmol_faq_a4(inputs)
	if (locale === "de") return de_massmol_faq_a4(inputs)
	if (locale === "nl") return nl_massmol_faq_a4(inputs)
	if (locale === "fr") return fr_massmol_faq_a4(inputs)
	if (locale === "it") return it_massmol_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_massmol_faq_a4(inputs)
	if (locale === "pt") return pt_massmol_faq_a4(inputs)
	if (locale === "ja") return ja_massmol_faq_a4(inputs)
	return zh_massmol_faq_a4(inputs)
};